import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Stack, ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { defaultTheme } from './theme';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import routes from './routes';
import WidthSideBar from './layouts/WithSideBar';
import AuthProvider from '@authentication/contexts/AuthContext';
import PrivateRoute from '@atoms/PrivateRoute';
import PublicRoute from '@atoms/PublicRoute';
import EnterprisesProvider from '@enterprise/contexts/enterprisesContext';
import { SnackbarProvider } from './contexts/SnackbarContext';
import { JDialogProvider } from './contexts/JDialogContext';
import UsersProvider from './modules/users/contexts/usersContext';
import CvVideosListProvider from '@cv-videos/contexts/cvVideosListContext';
import EstablishmentsProvider from '@establishment/contexts/establishmentsContext';
import JobsProvider from '@jobs/contexts/jobsContext';
import { JConfirmationBarProvider } from './contexts/JConfirmationBarContext';
import NotFoundPage from '@pages/NotFoundPage';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={defaultTheme}>
        <CssBaseline />
        <Stack direction="row">
          <Router>
            <Stack flex={1}>
              <SnackbarProvider>
                <JDialogProvider>
                  <JConfirmationBarProvider>
                    <AuthProvider>
                      <EnterprisesProvider>
                        <JobsProvider>
                          <CvVideosListProvider>
                            <EstablishmentsProvider>
                              <UsersProvider>
                                <Routes>
                                  {routes.map((route) => (
                                    <Route
                                      key={route.path}
                                      path={route.path}
                                      element={
                                        route.private ? (
                                          <PrivateRoute>
                                            {route.withSideBar
                                              ? WidthSideBar({
                                                  children: route.component,
                                                })
                                              : route.component}
                                          </PrivateRoute>
                                        ) : (
                                          <PublicRoute>
                                            {route.withSideBar
                                              ? WidthSideBar({
                                                  children: route.component,
                                                })
                                              : route.component}
                                          </PublicRoute>
                                        )
                                      }
                                    />
                                  ))}
                                  <Route path="*" element={<NotFoundPage />} />
                                </Routes>
                              </UsersProvider>
                            </EstablishmentsProvider>
                          </CvVideosListProvider>
                        </JobsProvider>
                      </EnterprisesProvider>
                    </AuthProvider>
                  </JConfirmationBarProvider>
                </JDialogProvider>
              </SnackbarProvider>
            </Stack>
          </Router>
        </Stack>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
